// Threshold value to avoid float rounding errors. Example: instead of x > 1 use x - EPSILON > 1
export const EPSILON = 1e-6;

// Default starting portfolio capital budget
export const DEFAULT_CAPITAL_BUDGET = 100;
